import Shepherd from "Shepherd.js";
import Cookies from "js-cookie";
import { safeAjax, safeFetch } from "./webapi";
import "shepherd.js/dist/css/shepherd.css";
const cookieName = "epa-portal-active-tour";
const queue = [];
const tours = {};
let entityGridsLoaded = false;
function waitForEntityGridsToLoad() {
    if (entityGridsLoaded) {
        return Promise.resolve([]);
    }
    const entityGrids = $(".entity-grid[data-defer-loading='false']");
    if (!entityGrids.length)
        return Promise.resolve([]);
    return Promise.all(entityGrids.map((_, entityGrid) => new Promise(resolve => $(entityGrid).on("loaded", e => {
        $(e.currentTarget).off("loaded");
        entityGridsLoaded = true;
        resolve();
    }))));
}
function startTour(tour, startingStepId) {
    if (Shepherd.activeTour) {
        queue.push({ tour, startingStepId });
        return;
    }
    if (startingStepId && tour?.steps?.at(0)?.id !== startingStepId) {
        tour.show(startingStepId);
        return;
    }
    tour.start();
}
function startTourById(tourId) {
    const { tour, startingStepId } = tours[tourId];
    if (!tour) {
        console.error("Tour not found: ", tourId);
        return;
    }
    startTour(tour, startingStepId);
}
function addNotification(id, tracking, user, setup, onStart, tourOptions, step) {
    const originalTitle = step.title;
    step.title = `<img src='/notification-warning.svg' /><div>${step.title}</div>`;
    const defaultOptions = {
        id: id,
        useModalOverlay: true,
        defaultStepOptions: {
            classes: "notification-tour",
            scrollTo: { behavior: "smooth", block: "center" },
            buttons: [{ text: "Acknowledge", action() { return this.complete(); } }]
        },
        steps: [step]
    };
    const tour = new Shepherd.Tour({
        ...defaultOptions,
        ...tourOptions
    });
    if (setup) {
        setup(tour);
    }
    if (onStart) {
        tour.on("start", function () {
            onStart();
        });
    }
    function updateLastVisited(trackingId) {
        safeAjax({
            type: "PATCH",
            url: `/_api/epa_notificationtrackings(${trackingId})`,
            contentType: "application/json",
            data: JSON.stringify({
                epa_pagelastvisitedon: new Date().toISOString()
            })
        }).fail(function (xhr, status, error) {
            console.error("Error updating record:", error);
        });
    }
    function attachTourEvents(trackingId) {
        tour.on("active", () => {
            safeAjax({
                type: "PATCH",
                url: `/_api/epa_notificationtrackings(${trackingId})`,
                contentType: "application/json",
                data: JSON.stringify({
                    epa_lastlaunchedon: new Date().toISOString()
                })
            }).fail(function (xhr, status, error) {
                console.error("Error updating record:", error);
            });
        });
        function updateLastAckknowledged() {
            safeAjax({
                type: "PATCH",
                url: `/_api/epa_notificationtrackings(${trackingId})`,
                contentType: "application/json",
                data: JSON.stringify({
                    epa_lastacknowledgedon: new Date().toISOString()
                })
            }).fail(function (xhr, status, error) {
                console.error("Error updating record:", error);
            });
        }
        tour.on("cancel", updateLastAckknowledged);
        tour.on("complete", updateLastAckknowledged);
    }
    function createTrackingRecord() {
        return new Promise((resolve, reject) => {
            safeAjax({
                type: "POST",
                url: "/_api/epa_notificationtrackings",
                contentType: "application/json",
                data: JSON.stringify({
                    epa_name: `${user.name} - ${originalTitle}`,
                    "epa_NotificationId@odata.bind": `/epa_notifications(${id})`,
                    "epa_ContactId@odata.bind": `/contacts(${user.id})`,
                    epa_pagelastvisitedon: new Date().toISOString()
                })
            })
                .done(function (response, status, xhr) {
                const trackingId = xhr.getResponseHeader("entityid");
                if (!trackingId) {
                    return reject("Unable to retrieve trackingId from response.");
                }
                attachTourEvents(trackingId);
                startTour(tour, null);
                resolve(tour);
            })
                .fail(function (xhr, status, error) {
                if (xhr?.responseJSON?.error?.cdscode === "0x80060892") {
                    console.warn("Duplicate tracking record detected. Reloading page.");
                    safeAjax({
                        url: `/_api/epa_notificationtrackings?$select=epa_notificationtrackingid&$filter=(_epa_notificationid_value eq ${id} and _epa_contactid_value eq ${user.id} and statecode eq 0)`,
                        type: "GET"
                    })
                        .done(function (response, status, xhr) {
                        const trackingId = response?.value?.at(0)
                            ?.epa_notificationtrackingid;
                        if (!trackingId) {
                            return reject("Unable to retrieve trackingId from response.");
                        }
                        attachTourEvents(trackingId);
                        startTour(tour, null);
                        resolve(tour);
                    })
                        .fail(function (xhr, status, error) {
                        reject(`Error retrieving tracking record: ${error}`);
                    });
                }
                else {
                    reject(`Error creating tracking record: ${error}`);
                }
            });
        });
    }
    if (!tracking) {
        return createTrackingRecord();
    }
    updateLastVisited(tracking.id);
    attachTourEvents(tracking.id);
    if (tracking.requiresRelaunch) {
        startTour(tour, null);
    }
    return Promise.resolve(tour);
}
function addTour(id, tourName, startingStepId, tracking, user, setup, onStart, tourOptions, steps) {
    if (!tourOptions.steps && !steps)
        Promise.reject("No steps provided.");
    const tourIsActive = Cookies.get(cookieName) === id;
    const defaultOptions = {
        id: id,
        tourName: tourName,
        useModalOverlay: true,
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            scrollTo: { behavior: "smooth", block: "center" }
        },
        steps: steps
    };
    const tour = new Shepherd.Tour({
        ...defaultOptions,
        ...tourOptions
    });
    if (setup) {
        setup(tour);
    }
    if (onStart) {
        tour.on("start", function () {
            onStart();
        });
    }
    function updateLastVisited(trackingId) {
        safeAjax({
            type: "PATCH",
            url: `/_api/epa_guidedtourtrackings(${trackingId})`,
            contentType: "application/json",
            data: JSON.stringify({
                epa_tourpagelastvisitedon: new Date().toISOString()
            })
        }).fail(function (xhr, status, error) {
            console.error("Error updating record:", error);
        });
    }
    function attachTourEvents(trackingId) {
        function saveCurrentStepOnHide() {
            if (document.hidden) {
                const currentStep = tour.getCurrentStep();
                if (currentStep) {
                    safeFetch(`/_api/epa_guidedtourtrackings(${trackingId})`, {
                        method: "PATCH",
                        headers: { "Content-Type": "application/json" },
                        keepalive: true,
                        body: JSON.stringify({
                            "epa_LastTourStepShownId@odata.bind": `/epa_guidedtoursteps(${currentStep.id})`
                        })
                    }).fail(function (xhr, status, error) {
                        console.error("Error updating record:", error);
                    });
                }
            }
        }
        tour.on("active", () => {
            Cookies.set(cookieName, id);
            document.addEventListener("visibilitychange", saveCurrentStepOnHide);
            safeAjax({
                type: "PATCH",
                url: `/_api/epa_guidedtourtrackings(${trackingId})`,
                contentType: "application/json",
                data: JSON.stringify({
                    epa_tourlastlaunchedon: new Date().toISOString()
                })
            }).fail(function (xhr, status, error) {
                console.error("Error updating record:", error);
            });
        });
        tour.on("inactive", () => {
            Cookies.remove(cookieName);
            document.removeEventListener("visibilitychange", saveCurrentStepOnHide);
        });
        tour.on("cancel", () => {
            const currentStep = tour.getCurrentStep();
            if (currentStep) {
                safeAjax({
                    type: "PATCH",
                    url: `/_api/epa_guidedtourtrackings(${trackingId})`,
                    contentType: "application/json",
                    data: JSON.stringify({
                        epa_tourcancelledon: new Date().toISOString(),
                        "epa_LastTourStepShownId@odata.bind": `/epa_guidedtoursteps(${currentStep.id})`
                    })
                }).fail(function (xhr, status, error) {
                    console.error("Error updating record:", error);
                });
            }
        });
        tour.on("complete", () => {
            const currentStep = tour.getCurrentStep();
            if (currentStep) {
                safeAjax({
                    type: "PATCH",
                    url: `/_api/epa_guidedtourtrackings(${trackingId})`,
                    contentType: "application/json",
                    data: JSON.stringify({
                        epa_tourcompletedon: new Date().toISOString(),
                        "epa_LastTourStepShownId@odata.bind": `/epa_guidedtoursteps(${currentStep.id})`
                    })
                }).fail(function (xhr, status, error) {
                    console.error("Error updating record:", error);
                });
            }
        });
    }
    function initialiseTour(trackingId) {
        tours[id] = {
            tour,
            startingStepId
        };
        attachTourEvents(trackingId);
        startTourById(id);
    }
    function createTrackingRecord() {
        return new Promise((resolve, reject) => {
            safeAjax({
                type: "POST",
                url: "/_api/epa_guidedtourtrackings",
                contentType: "application/json",
                data: JSON.stringify({
                    epa_name: `${user.name} - ${tourName}`,
                    "epa_GuidedTourId@odata.bind": `/epa_guidedtours(${id})`,
                    "epa_ContactId@odata.bind": `/contacts(${user.id})`,
                    epa_tourpagelastvisitedon: new Date().toISOString()
                })
            })
                .done(function (response, status, xhr) {
                const trackingId = xhr.getResponseHeader("entityid");
                if (!trackingId) {
                    return reject("Unable to retrieve trackingId from response.");
                }
                initialiseTour(trackingId);
                resolve(tour);
            })
                .fail(function (xhr, status, error) {
                if (xhr?.responseJSON?.error?.cdscode === "0x80060892") {
                    console.warn("Duplicate tracking record detected. Reloading page.");
                    safeAjax({
                        url: `/_api/epa_guidedtourtrackings?$select=epa_guidedtourtrackingid&$filter=(_epa_guidedtourid_value eq ${id} and _epa_contactid_value eq ${user.id} and statecode eq 0)`,
                        type: "GET"
                    })
                        .done(function (response, status, xhr) {
                        const trackingId = response?.value?.at(0)
                            ?.epa_guidedtourtrackingid;
                        if (!trackingId) {
                            return reject("Unable to retrieve trackingId from response.");
                        }
                        initialiseTour(trackingId);
                        resolve(tour);
                    })
                        .fail(function (xhr, status, error) {
                        reject(`Error retrieving tracking record: ${error}`);
                    });
                }
                else {
                    reject(`Error creating tracking record: ${error}`);
                }
            });
        });
    }
    if (!tracking) {
        return createTrackingRecord();
    }
    tours[id] = {
        tour,
        startingStepId
    };
    updateLastVisited(tracking.id);
    attachTourEvents(tracking.id);
    if (tracking.requiresRelaunch || tourIsActive) {
        startTourById(id);
    }
    return Promise.resolve(tour);
}
function addTourButtons(buttonContainerId) {
    const tourButtonsContainer = document.getElementById(buttonContainerId);
    if (tourButtonsContainer) {
        const tourIds = Object.keys(tours);
        if (tourIds.length === 1) {
            const div = document.createElement("div");
            const button = document.createElement("button");
            button.className = "btn btn-primary";
            button.onclick = () => startTourById(tourIds[0]);
            const textSpan = document.createElement("span");
            textSpan.className = "visible-sm visible-md visible-lg";
            textSpan.textContent = "Start Tour";
            button.append(textSpan);
            const icon = document.createElement("img");
            icon.className = "hidden-sm hidden-md hidden-lg";
            icon.src = "/tour-button-icon.svg";
            button.append(icon);
            div.append(button);
            tourButtonsContainer.prepend(div);
        }
        else if (tourIds.length > 1) {
            const dropdown = document.createElement("div");
            dropdown.className = "dropdown";
            const button = document.createElement("button");
            button.className = "btn btn-primary dropdown-toggle";
            button.setAttribute("data-toggle", "dropdown");
            dropdown.append(button);
            const textSpan = document.createElement("span");
            textSpan.className = "visible-sm visible-md visible-lg";
            textSpan.textContent = "Select Tour";
            button.append(textSpan);
            const icon = document.createElement("img");
            icon.className = "hidden-sm hidden-md hidden-lg";
            icon.src = "/tour-button-icon.svg";
            button.append(icon);
            const dropdownMenu = document.createElement("ul");
            dropdownMenu.className = "dropdown-menu";
            tourIds.forEach(tourId => {
                const dropdownListItem = document.createElement("li");
                const dropdownItem = document.createElement("a");
                dropdownItem.className = "dropdown-item";
                dropdownItem.textContent = `Start ${tours[tourId].tour.options.tourName} Tour`;
                dropdownItem.onclick = () => startTourById(tourId);
                dropdownListItem.append(dropdownItem);
                dropdownMenu.append(dropdownListItem);
            });
            dropdown.append(dropdownMenu);
            tourButtonsContainer.prepend(dropdown);
        }
    }
}
Shepherd.on("inactive", () => {
    const item = queue.shift();
    if (item) {
        const { tour, startingStepId } = item;
        startTour(tour, startingStepId);
    }
});
Object.assign(window, {
    waitForEntityGridsToLoad,
    addNotification,
    addTour,
    startTourById,
    addTourButtons
});
